module.exports = __webpack_public_path__ + "static/img/culturePic2.739b0ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/culturePic2.jpg
// module id = dt+N
// module chunks = 0